var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC2Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29636_344474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29636_344474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0867 24.5805H21.9133L20.9371 18.9909C21.469 18.7751 21.8954 18.4404 22.2163 17.9868C22.5371 17.5332 22.6975 17.0245 22.6975 16.4609C22.6975 15.7168 22.4338 15.0811 21.9062 14.5539C21.3785 14.0269 20.7422 13.7634 19.9975 13.7634C19.2528 13.7634 18.6174 14.0269 18.0913 14.5539C17.5654 15.0811 17.3025 15.7168 17.3025 16.4609C17.3025 17.0245 17.4629 17.5332 17.7838 17.9868C18.1046 18.4404 18.531 18.7751 19.0629 18.9909L18.0867 24.5805ZM20 35.7814C16.3839 34.7914 13.3965 32.647 11.0379 29.3484C8.67931 26.0501 7.5 22.3861 7.5 18.3564V8.89052L20 4.21094L32.5 8.89052V18.3564C32.5 22.3861 31.3207 26.0501 28.9621 29.3484C26.6035 32.647 23.6161 34.7914 20 35.7814Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2Icon);
export default __webpack_public_path__ + "static/media/c2Icon.034025333038bcd9d2881d7fc57ae6c1.svg";
export { ForwardRef as ReactComponent };